/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import Grid from "@mui/material/Grid";
import summaryStyle from "../summaryStyle";
import GridEditRow from "../../Common/GridEditRow/GridEditRow";
import Typography from "@mui/material/Typography";
import SummaryDetailsItem from "../../Common/SummaryDetailsItem/SummaryDetailsItem";
import {translate} from "../../../../services/translations/translations";
import {AbstractCase} from "../../../../types/Entities/AbstractCase";
import {Box} from "@mui/material";

type TerminationProps = {
  basePath: string;
  product: AbstractCase;
};
const Termination = ({basePath, product}: TerminationProps) => {
  const section = "termination";
  const formPath = basePath + "/kuendigung";
  return (
    <>
      <Grid item xs={12} sx={summaryStyle.subHeadline}>
        <Typography variant={"h5"}>Kündigung</Typography>
      </Grid>
      <SummaryDetailsItem caseData={product} formUrl={formPath} fieldPath={"contractTerminated"} anchorId={section}/>
      <SummaryDetailsItem caseData={product} formUrl={formPath} fieldType={"date"}
                          fieldPath={"contractTerminationReceivedDate"} anchorId={section}/>
      <SummaryDetailsItem caseData={product} formUrl={formPath} fieldPath={"terminationNoticeType"} anchorId={section}/>
      <SummaryDetailsItem caseData={product} formUrl={formPath} fieldPath={"preferredOutcome"} anchorId={section}/>
      <>
        <Grid item xs={12} sx={summaryStyle.question}>
          <Box id={"terminationObstacles"} sx={summaryStyle.scrollToAnchor} />
          {translate("settlement.terminationObstacles.label", product)}
        </Grid>
        <GridEditRow
          item
          xs={12}
          to={{
            pathname: basePath + "/kuendigung",
            state: {
              section: section,
              field: "terminationObstacles",
            },
          }}
        >
          {product.terminationObstacles.length
            ? product.terminationObstacles.map((value: string) => translate(`settlement.terminationObstacles.options.${value}.label`, product)).join(", ")
            : "Kein besonderer Kündigungsschutz"}
        </GridEditRow>
      </>
    </>
  );
};

export default Termination;
